/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, {
  useEffect, useState, ReactElement, ReactNode
} from 'react';
import { useMatch, useLocation, Link } from 'react-router';

type NavigationTabsProps = {
  children?: ReactNode;
  className?: string;
  kerang?: boolean;
}

type SearchParams = {
  pathname: string;
  search?: string;
}

export function NavigationTabs({ children, className, kerang }: NavigationTabsProps): ReactElement {
  if (kerang) {
    return (
      <ul className={['nav nav-tabs nav-tabs-panel', className].filter(Boolean).join(' ')}>
        {children}
      </ul>
    );
  }

  return (
    <ul className={['nav nav-tabs view-lg nav-tabs-panel', className].filter(Boolean).join(' ')}>
      {children}
    </ul>
  );
}

export function NavigationTab({
  active, onClick, title, children, className, kerang, disabled = false
}: {
  active?: boolean,
  onClick?: (event: React.MouseEvent) => void,
  title?: string | ReactNode,
  children?: ReactNode,
  className?: string,
  kerang?: boolean,
  disabled?: boolean
}): ReactElement {
  if (kerang) {
    return (
      <li role="presentation" className={`nav-item ${active ? 'active' : ''}`}>
        {!children && (
          <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={`bg-transparent text-black text-decoration-none text-center
              ${active ? '' : 'fw-lighter'} ${className || ''}`}
            aria-selected={active}
          >
            {title}
          </button>
        )}
      </li>
    );
  }

  return (
    <li role="presentation" className={`u-flexGrow1 flex-grow-1 ${active ? 'active' : ''}`}>
      {!children && (
        <button
          type="button"
          onClick={onClick}
          disabled={disabled}
          className={`clickable btn-link u-textAlignCenter text-center ${className || ''}`}
        >
          {title}
        </button>
      )}
    </li>
  );
}

export function RouterNavigationLink(
  {
    to, title, canMaximize
  }: { to: string, title: string, canMaximize?: boolean }
): ReactElement {
  const { search } = useLocation();
  const match = useMatch(to);
  const [path, setPath] = useState<SearchParams>({ pathname: to });

  useEffect(() => {
    setPath({ pathname: to, search: search.toString() });
  }, [search]);

  const tabClassName = canMaximize ? 'u-flexGrow1 flex-grow-1' : '';

  return (
    <li role="presentation" className={`${tabClassName} ${match ? 'active' : ''}`}>
      <Link to={path}>{title}</Link>
    </li>
  );
}
